import { BusinessInfoPhase } from '~/swagger/companies/Api';
import type { BusinessInfoItemDto } from '~/swagger/companies/Api';

export const resolveDefaultBusinessInfoId = (items: BusinessInfoItemDto[]) => {
  if (items.length === 0) return undefined;

  return (
    items.find((item) => item.isPrimary)?.id ?? items.find((item) => item.phase === BusinessInfoPhase.Materialized)?.id ?? items[0]?.id
  );
};
